import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface CounterState {
  step: number
}

const initialState: CounterState = {
  step: 0,
}

export const Slice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
     
      state.step += 1
    },
    decrement: (state) => {

      state.step -= 1
    },
    stepSet: (state, action) => {
      
    const {step} = action.payload;
    state.step = step;
    
  }
  },
})

// Action creators are generated for each case reducer function
export const { increment, decrement, stepSet } = Slice.actions

export default Slice.reducer